import React, { useState, useEffect } from "react";
import api from "../../api";
import Select from "react-select";
import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    MenuItem,
} from "@mui/material";
import {
    FaTrash,
    FaChalkboard,
    FaEdit,
    FaTimesCircle,
    FaSave,
    FaPlusCircle,
} from "react-icons/fa";

const FeesStructureListPage = () => {
    const [fees, setFees] = useState([]);
    const [loading, setLoading] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [addModal, setAddModal] = useState(false);
    const [selectedFee, setSelectedFee] = useState(null);
    const [newFee, setNewFee] = useState({
        note: "",
        application_fee: "",
        status: "",
    });
    const [msg, setMsg] = useState(null);

    const schoolId = localStorage.getItem("school_id");

    // API endpoints
    const feesURL = `/fees_structure/list_fee`;
    const addURL = `/fees_structure/add_fee`;

    // Fetch fees list
    const fetchFees = async () => {
        setLoading(true);
        try {
            const url = feesURL
                ? `${feesURL}?school_id=${schoolId}`
                : `${feesURL}?school_id=${schoolId}`;
            const res = await api.get(url);
            if (res.data?.status) setFees(res.data.data || []);
            else setFees([]);
        } catch (err) {
            console.error("Error fetching fees:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchFees();
    }, []);


    const openEditModal = (fee) => {
        setSelectedFee(fee);
        setEditModal(true);
    };

    const handleEditChange = (key, value) => {
        setSelectedFee({ ...selectedFee, [key]: value });

    };

    const handleSaveEdit = async () => {
        try {
            const res = await api.post(`/fees_structure/update_fee/${selectedFee.id}`, selectedFee);
            console.log('playload', selectedFee);
            if (res.data.status) {
                setMsg({ type: "success", text: "Updated successfully!" });
                fetchFees();
                setEditModal(false);
            } else {
                setMsg({ type: "error", text: res.data.message });
            }
        } catch (err) {
            setMsg({
                type: "error",
                text: err.response?.data?.message || "Failed to update.",
            });
        }
    };

    const handleAddFee = async () => {
        if (!newFee.note || !newFee.application_fee || !newFee.status) {
            alert("Please fill all required fields.");
            return;
        }
        try {
            const payload = {
                school_id: schoolId,
                note: newFee.note,
                application_fee: newFee.application_fee,
                status: newFee.status,
            };

            const res = await api.post(addURL, payload);
            if (res.data.status) {
                setMsg({ type: "success", text: "Fee added successfully!" });
                setAddModal(false);
                fetchFees();
                setNewFee({ note: "", application_fee: "", status: "" });
            } else {
                setMsg({ type: "error", text: res.data.message });
            }
        } catch (err) {
            setMsg({
                type: "error",
                text: err.response?.data?.message || "Failed to add fee.",
            });
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this department?")) return;
        try {
            const res = await api.post(`/fees_structure/delete_fee`, { id });
            const json = res.data;
            if (json?.status) {
                setMsg({ type: "success", text: json.message || "Deleted" });
            } else {
                setMsg({ type: "error", text: json?.message || "Delete failed" });
            }
            fetchFees();
        } catch (err) {
            console.error("Delete error", err);
            setMsg({
                type: "error",
                text: err.response?.data?.message || err.message || "Network error",
            });
        }
    };
    return (
        <Box sx={{ background: "#f4f6f8", minHeight: "100vh", py: 4 }}>
            <Paper
                elevation={3}
                sx={{
                    maxWidth: 1200,
                    mx: "auto",
                    p: 3,
                    borderRadius: 3,
                    bgcolor: "#fff",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 3,
                        flexWrap: "wrap",
                        gap: 2,
                    }}
                >
                    <Typography
                        variant="h5"
                        sx={{
                            fontWeight: 700,
                            color: "#004aad",
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                        }}
                    >
                        <FaChalkboard />Others Fees Structure
                    </Typography>

                    <Button
                        variant="contained"
                        color="success"
                        startIcon={<FaPlusCircle />}
                        onClick={() => setAddModal(true)}
                    >
                        Add New Fee
                    </Button>
                </Box>

                {loading ? (
                    <Box sx={{ textAlign: "center", mt: 3 }}>
                        <CircularProgress color="primary" />
                    </Box>
                ) : fees.length === 0 ? (
                    <Typography color="textSecondary" sx={{ mt: 2 }}>
                        No fee records found.
                    </Typography>
                ) : (
                    <TableContainer component={Paper} elevation={2} sx={{ borderRadius: 2 }}>
                        <Table>
                            <TableHead sx={{ bgcolor: "#004aad" }}>
                                <TableRow>
                                    {[
                                        "ID",
                                        "Fee Type",
                                        "Amount (₹)",
                                        "Status",
                                        "Action",
                                    ].map((head) => (
                                        <TableCell key={head} sx={{ color: "#ffffff", fontWeight: 600, textAlign: "center" }}>
                                            {head}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody >
                                {fees.map((f) => (
                                    <TableRow key={f.id} hover>
                                        <TableCell sx={{ textAlign: "center" }}>{f.id}</TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>{f.note}</TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>{f.application_fee}</TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>{f.status === "1" ? "Active" : "In-active"}</TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>
                                            <Button
                                                variant="outlined"
                                                color="info"
                                                size="small"
                                                startIcon={<FaEdit />}
                                                onClick={() => openEditModal(f)}
                                                style={{ color: "#0077cc", cursor: "pointer", marginRight: "15px" }}
                                            >
                                                Edit
                                            </Button>
                                            <Button
                                                variant="outlined"
                                                color="info"
                                                size="small"
                                                startIcon={<FaTrash />}
                                                onClick={() => handleDelete(f.id)}
                                                style={{ color: "#cc0000ff", cursor: "pointer" }}
                                            >
                                                Delete
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Paper>

            {/* Edit Modal */}
            <Dialog open={editModal} onClose={() => setEditModal(false)} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ fontWeight: 700, color: "#004aad" }}>
                    ✏️ Edit Fee Structure
                </DialogTitle>
                <DialogContent>
                    {selectedFee && (
                        <>
                            <TextField
                                fullWidth
                                label="Fee Type"
                                margin="dense"
                                value={selectedFee.note}
                                onChange={(e) => handleEditChange("note", e.target.value)}
                            />
                            <TextField
                                fullWidth
                                label="Amount (₹)"
                                type="number"
                                margin="dense"
                                value={selectedFee.application_fee}
                                onChange={(e) => handleEditChange("application_fee", e.target.value)}
                            />
                            <TextField
                                select
                                fullWidth
                                label="Status"
                                margin="dense"
                                value={selectedFee.status}
                                onChange={(e) => handleEditChange("status", e.target.value)}
                            >
                                <MenuItem value="">Select</MenuItem>
                                <MenuItem value="1">Active</MenuItem>
                                <MenuItem value="0">In-active</MenuItem>
                            </TextField>
                        </>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button
                        color="error"
                        variant="outlined"
                        startIcon={<FaTimesCircle />}
                        onClick={() => setEditModal(false)}
                    >
                        Cancel
                    </Button>
                    <Button
                        color="primary"
                        variant="contained"
                        startIcon={<FaSave />}
                        onClick={handleSaveEdit}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Add New Fee Modal */}
            <Dialog open={addModal} onClose={() => setAddModal(false)} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ fontWeight: 700, color: "#2e7d32" }}>
                    ➕ Add New Fee Structure
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ mt: 1 }}>
                        <TextField
                            fullWidth
                            label="Fee Type"
                            margin="dense"
                            value={newFee.note}
                            onChange={(e) => setNewFee({ ...newFee, note: e.target.value })}
                        />
                        <TextField
                            fullWidth
                            label="Amount (₹)"
                            type="number"
                            margin="dense"
                            value={newFee.application_fee}
                            onChange={(e) => setNewFee({ ...newFee, application_fee: e.target.value })}
                        />

                        <TextField
                            select
                            fullWidth
                            label="Status"
                            margin="dense"
                            value={newFee.status}
                            onChange={(e) => setNewFee({ ...newFee, status: e.target.value })}
                        >
                            <MenuItem value="">Select</MenuItem>
                            <MenuItem value="1">Active</MenuItem>
                            <MenuItem value="0">In-active</MenuItem>
                        </TextField>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button
                        color="error"
                        variant="outlined"
                        startIcon={<FaTimesCircle />}
                        onClick={() => setAddModal(false)}
                    >
                        Cancel
                    </Button>
                    <Button
                        color="success"
                        variant="contained"
                        startIcon={<FaSave />}
                        onClick={handleAddFee}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default FeesStructureListPage;
